import React from 'react'
import { HOUR_HEIGHT } from '../../../../utils'
import classnames from 'classnames'


export default function Hour({ index, hour }) {
  return (
    <div className={classnames("text-center", { "border-top": index != 0 })} style={{height: HOUR_HEIGHT}}>
      { hour }
    </div>
  )
}